import { useTripDesignerConfig } from '../config/TripDesignerConfigProvider';
import { useExperience } from './useTripStoreSelectors';
import { canMutateHotelForDay, canRemoveHotelForDay } from '../logic/ownership';

/**
 * Whether the current app may mutate/remove a given day's hotel, per
 * `useTripDesignerConfig().isOwnProduct`. With the default predicate every
 * hotel is both mutable and removable — TO's behaviour, since it has no
 * ownership concept.
 */
export function useHotelOwnership(dayIndex: number, hotel: any) {
  const { isOwnProduct } = useTripDesignerConfig();
  const experience = useExperience(dayIndex);

  return {
    canMutateHotel: canMutateHotelForDay(hotel, isOwnProduct),
    canRemoveHotel: canRemoveHotelForDay(hotel, experience, isOwnProduct),
  };
}
